import { useTypedSelector } from '../../../store/reducers/use-typed-selector';
import { EPermissions, Session } from '../../../types/working-model';
import { OptionalComponent } from '../../../utils/optional-component';
import { useShowGreenroomButton } from './use-show-greenroom-button';
import { userHasRoleOnActiveChannel } from 'utils/utils';

interface Props {
	session: Session;
}

export default function OpenGRButton({ session }: Props): JSX.Element {
	const publishedUrl = useTypedSelector(state => state.CreateEventReducer.publishedUrl);
	const token = useTypedSelector(state => state.AuthReducer.token);
	const user = useTypedSelector(state => state.AuthReducer.user);

	const allowedPermission = userHasRoleOnActiveChannel([
		EPermissions.Owner,
		EPermissions.Admin,
		EPermissions.Analytics,
		EPermissions.Moderation,
		EPermissions.ModeratorRegistrant,
		EPermissions.PasscodeManager,
		EPermissions.Editor,
		EPermissions.GroupAdmin,
		EPermissions.Viewer,
		EPermissions.Builder,
		EPermissions.Producer,
	], user);

	const shouldHaveGreenroomProducerUrl = useShowGreenroomButton(session);

	return (
		<OptionalComponent display={shouldHaveGreenroomProducerUrl && allowedPermission && !!token}>
			<div title={!publishedUrl ? "Project not yet published" : undefined}>
				<a
					className="go-to-greenroom anchor-as-button lemonade"
					href={`${process.env.REACT_APP_GREENROOM_FRONTEND_URL}/create/${session.uuid}`}
					target="_blank"
					rel="noreferrer"
				>
					Greenroom®
				</a>
			</div>
		</OptionalComponent>
	);
}
